import getAll from 'actions/base/getAll'
import getCollection from './getCollection'

const getAllGroups = async (props = {}) => getAll(props, getCollection)

export default getAllGroups
